import React from "react";
import { AudioButton, AudioWrapper, StyledAudioIcon } from "./_.styled";

const AudioPlayer = ({ togglePlay }) => {
  return (
    <AudioWrapper data-testid="audioContainer">
      <AudioButton onClick={togglePlay} data-testid="audioButton">
        <StyledAudioIcon
          icon={{ glyph: "volume_up" }}
          data-testid="audioIcon"
        />
      </AudioButton>
    </AudioWrapper>
  );
};

export default AudioPlayer;
